module.exports = __webpack_public_path__ + "img/bankokbank.6f594625.jpg";